'use client';

import { colors } from '@/lib/mx-asurion-ui-react';
import styled from 'styled-components';

export const GridLayout = styled.div`
  display: grid;
  gap: 1rem;
  grid-template-columns: 40% 60%;
  grid-template-areas: 'logoArea linksArea';
  @media (max-width: 768px) {
    grid-template-areas:
      'logoArea'
      'linksArea';
  }
`;

export const LinksArea = styled.div`
  grid-area: linksArea;
`;

export const LogoArea = styled.div`
  grid-area: logoArea;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const StyledHeader = styled.header`
  box-sizing: border-box;
  padding: 0.75rem 2rem;
  background: ${colors.white};
  color: ${colors.black};
  max-width: 1440px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  border-bottom: 1px solid #f1f1f1;
`;

export const StyledHeaderLinks = styled.ul`
  margin: 0.5rem 0 0 0;
  list-style: none;
  display: flex;
  flex-flow: row wrap;

  li::after {
    padding: 0 0.5rem;
    content: '|';
  }
  li:last-child::after {
    content: '';
  }
`;

export const StyledHeaderWrapper = styled.div`
  flex-shrink: 0;
  width: 100%;
  background: ${colors.white};
  display: flex;
  justify-content: center;
`;

export const StyledHeaderLogoContainer = styled.div`
  display: flex;
  gap: 1rem;
`;

export const StyledHeaderContentContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row-reverse;
  gap: 1rem;
`;

export const StyledPriceHeader = styled.text`
  padding: 1.5rem;
  display: flex;
  justify-content: flex-start;
  font-size: 20px;
  color: #000000;
  border-bottom: 1px solid #f1f1f1;
`;
